module.exports = "<div class=py-8> <md-button class=\"coreo-button block\" ng-click=ctrl.onClick()> <ng-transclude></ng-transclude> </md-button> </div>";